import React from "react";

export const LinkedInCircleFilledIcon = (props) => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.818359" width="40" height="40" rx="20" fill="#18428E" />
      <path
        d="M24 16.8184C25.5913 16.8184 27.1174 17.4505 28.2426 18.5757C29.3679 19.7009 30 21.2271 30 22.8184V29.8184H26V22.8184C26 22.2879 25.7893 21.7792 25.4142 21.4041C25.0391 21.0291 24.5304 20.8184 24 20.8184C23.4696 20.8184 22.9609 21.0291 22.5858 21.4041C22.2107 21.7792 22 22.2879 22 22.8184V29.8184H18V22.8184C18 21.2271 18.6321 19.7009 19.7574 18.5757C20.8826 17.4505 22.4087 16.8184 24 16.8184Z"
        fill="white"
      />
      <path d="M14 17.8184H10V29.8184H14V17.8184Z" fill="white" />
      <path
        d="M12 14.8184C13.1046 14.8184 14 13.9229 14 12.8184C14 11.7138 13.1046 10.8184 12 10.8184C10.8954 10.8184 10 11.7138 10 12.8184C10 13.9229 10.8954 14.8184 12 14.8184Z"
        fill="white"
      />
    </svg>
  );
};
